var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownFillBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3537 6.35375L8.35375 11.3538C8.30731 11.4002 8.25217 11.4371 8.19147 11.4623C8.13077 11.4874 8.06571 11.5004 8 11.5004C7.93429 11.5004 7.86923 11.4874 7.80853 11.4623C7.74783 11.4371 7.69268 11.4002 7.64625 11.3538L2.64625 6.35375C2.57624 6.28382 2.52856 6.1947 2.50923 6.09765C2.48991 6.00061 2.49981 5.90002 2.53769 5.8086C2.57556 5.71719 2.63971 5.63908 2.72201 5.58414C2.8043 5.5292 2.90105 5.49992 3 5.5H13C13.0989 5.49992 13.1957 5.5292 13.278 5.58414C13.3603 5.63908 13.4244 5.71719 13.4623 5.8086C13.5002 5.90002 13.5101 6.00061 13.4908 6.09765C13.4714 6.1947 13.4238 6.28382 13.3537 6.35375Z",
    fill: "#0B1C56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownFillBlack);
export default __webpack_public_path__ + "static/media/dropdown-fill-black.aca1abc0046397c489ef0450380fda5d.svg";
export { ForwardRef as ReactComponent };